import ApiService from '@/common/api.service'

const RESOURCE = 'messages'
const MessageService = {
  getList (params) {
    return ApiService.query(RESOURCE, params)
  },
  get (id, params) {
    return ApiService.get(RESOURCE, id, params)
  },
  getImage (id, params) {
    return ApiService.query(`${RESOURCE}/${id}/image`, params)
  },
  getVoice (id, params) {
    return ApiService.query(`${RESOURCE}/${id}/voice`, params)
  },
  getThreads (params) {
    return ApiService.query('threads', params)
  }
}
export default MessageService
